// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"View5_wrapper__17i8g","topRow":"View5_topRow__2emp3","mainUser":"View5_mainUser__3XX-b","user":"View5_user__2dd-T","bottomRow":"View5_bottomRow__1yfuW"};